import {
    RECURRENT_COUNT_MAX,
    RECURRENT_COUNT_MIN,
    RECURRENT_INTERVAL_MAX,
    RECURRENT_INTERVAL_MIN,
    RECURRENT_MONTH_DAY_MAX,
    RECURRENT_MONTH_DAY_MIN,
    RECURRENT_WEEKDAYS,
    type RecurrentData,
    type RecurrentFormValue,
    type RecurrentWeekday,
} from '@econtractor/types';

export const emptyRecurrentData = (): RecurrentData => ({
    interval: 1,
    frequency: 'day',
    weekdays: [],
    monthDay: null,
    endType: 'never',
    endDate: null,
    endCount: null,
});

export const emptyRecurrentValue = (): RecurrentFormValue => ({
    enabled: false,
    data: null,
    allowOverlap: false,
});

const weekdaySet = new Set<number>(RECURRENT_WEEKDAYS);

export const isRecurrentDataValid = (data: RecurrentData | null | undefined): data is RecurrentData => {
    if (!data) return false;
    if (!Number.isInteger(data.interval) || data.interval < RECURRENT_INTERVAL_MIN || data.interval > RECURRENT_INTERVAL_MAX) {
        return false;
    }
    if (data.frequency === 'week') {
        if (!data.weekdays.length) return false;
        if (data.weekdays.some((day) => !weekdaySet.has(day))) return false;
    }
    if (data.frequency === 'month') {
        if (data.monthDay == null || data.monthDay < RECURRENT_MONTH_DAY_MIN || data.monthDay > RECURRENT_MONTH_DAY_MAX) {
            return false;
        }
    }
    if (data.endType === 'count') {
        if (data.endCount == null || data.endCount < RECURRENT_COUNT_MIN || data.endCount > RECURRENT_COUNT_MAX) {
            return false;
        }
    }
    if (data.endType === 'date') {
        if (data.endDate == null || !Number.isFinite(data.endDate) || data.endDate <= 0) return false;
    }
    return true;
};

export const withFrequency = (data: RecurrentData, frequency: RecurrentData['frequency'], monthDay: number): RecurrentData => {
    if (frequency === 'week') {
        return { ...data, frequency, weekdays: data.weekdays.length ? data.weekdays : [1], monthDay: null };
    }
    if (frequency === 'month') {
        const day = data.monthDay && data.monthDay >= 1 ? data.monthDay : monthDay;
        return { ...data, frequency, weekdays: [], monthDay: day };
    }
    return { ...data, frequency, weekdays: [], monthDay: null };
};

export const toggleWeekday = (weekdays: RecurrentWeekday[], day: RecurrentWeekday): RecurrentWeekday[] => {
    if (weekdays.includes(day)) {
        if (weekdays.length === 1) return weekdays;
        return weekdays.filter((item) => item !== day);
    }
    return [...weekdays, day].sort((a, b) => a - b);
};
